<table class="risk-table">
  <thead>
    <tr>
      <th>{{'new_entries.description' | translate}}</th>
      <th>{{'new_entries.from' | translate}}</th>
      <th>{{'new_entries.to' | translate}}</th>
      <th>{{'new_entries.classification' | translate}}</th>
      <th>{{'new_entries.percentage' | translate}}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let risk of riskLevels; let i = index">
      <td>{{'new_entries.display_documents_between' | translate}}</td>
      <td [class.disabled]="risk.from == 0">
        <input min="0" [max]="getMaxFromValue(i)" type="number" [(ngModel)]="risk.from"
          (input)="onInputChange(i, 'from', $event.target.valueAsNumber)"
          (blur)="onInputChange(i, 'from', $event.target.valueAsNumber)"
          (paste)="onInputChange(i, 'from', $event.target.valueAsNumber)" /> %

      </td>
      <td [class.disabled]="risk.to == 100">
        <input [min]="getMinToValue(i)" [max]="getMaxToValue(i)" type="number" [(ngModel)]="risk.to"
          (input)="onInputChange(i, 'to', $event.target.valueAsNumber)"
          (blur)="onInputChange(i, 'to', $event.target.valueAsNumber)"
          (paste)="onInputChange(i, 'to', $event.target.valueAsNumber)" /> %

      </td>
      <td>
        <span class="risk-badge" [ngClass]="risk.class">
          <span class="dot"></span> {{ risk.label }}
        </span>
      </td>
      <td>
        <span class="risk-badge no_label" [ngClass]="risk.class">
          <span class="dot"></span>
        </span>
      </td>
    </tr>

  </tbody>
</table>